<template>
  <v-dialog v-model="showDialog" max-width="750px">
    <template v-slot:activator="{ on }">
      <v-btn small color="primary" v-on="on" @click="initt">#Cheque</v-btn>
    </template>
    <v-card>
      <v-card-title>Generar cheques</v-card-title>
      <v-card-text>
        <v-data-table
          v-if="!generado"
          :headers="headers"
          :items="talonarios"
          dense
        >
          <template v-slot:[`item.controls`]="props">
            <v-btn
              v-if="!generado"
              small
              color="warning"
              class="btn btn-primary btn-sm"
              :loading="loading"
              @click="generarCheques(props.item.idTalonarioCheque)"
              >GENERAR
            </v-btn>
          </template>
        </v-data-table>
        {{ message }}
      </v-card-text>
      <div class="red--text">{{ errorMessage }}</div>
      <v-card-actions>
        <v-btn small color="primary" @click="showDialog = false">VOLVER</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  props: ["pagoId"],
  data() {
    return {
      message: "",
      errorMessage: "",
      generado: false,
      showDialog: false,
      talonarios: [],
      loading: false,
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 1000) || "Maximo 100 caracteres",
        counter10: (value) =>
          (value && value.length <= 10) || "Maximo 10 caracteres",
      },
      validForm: false,
      headers: [
        { text: "Id", value: "idTalonarioCheque" },
        { text: "Banco", value: "banco" },
        { text: "Cuenta", value: "numeroCuenta" },
        { text: "#Desde", value: "numeroDesde" },
        { text: "#Hasta", value: "numeroHasta" },
        { text: "#Cantidad", value: "cantidad" },
        { text: "Accion", value: "controls", sortable: false },
      ],
    };
  },
  methods: {
    generarCheques(idTalonarioCheque) {
      this.loading = true;
      //this.showDialog = false;
      const params = {
        idTalonarioCheque: idTalonarioCheque,
        pagoId: this.pagoId,
      };
      console.log('params', params)
      axios
        .post("/pago/generarCheque", null, { params })
        .then((response) => {
          console.log("*****", response);
          this.loading = false;
          this.generado = true;
          this.talonarios = [];
          this.message = "Cheques generados con exito";
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    initt() {
      this.message = "";
      this.generado = false;
      this.errorMessage = "";
      axios
        .get("/pago/talonariosCheque")
        .then((response) => {
          console.log("*****", response);
          this.talonarios = response.data.map((r) => {
            return {
              ...r,
              cantidad: (r.cantidad = r.numeroHasta - r.numeroDesde + 1),
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>